import React from 'react';
import ManageWorkspaces from '../../../components/AdminWorkspaces/ManageWorkspaces';

const AdminWorkspacesPage = () => {
    return (
        <div className="w-full">
            <ManageWorkspaces />
        </div>
    );
};

export default AdminWorkspacesPage;

